import { createStore } from 'vuex';

import like from '@/store/modules/like/index.js';
import auth from '@/store/modules/auth/index.js';
import post from '@/store/modules/post/index.js';
import chat from '@/store/modules/chat/index.js';
import photo from '@/store/modules/photo/index.js';
import friend from '@/store/modules/friend/index.js';
import search from '@/store/modules/search/index.js';
import comment from '@/store/modules/comment/index.js';
import profile from '@/store/modules/profile/index.js';

const store = createStore({
    modules: {
        auth,
        post,
        like,
        comment,
        search,
        friend,
        chat,
        photo,
        profile
    }
});

export default store;